export const CustomerText = {
    M1: {
        text1: '帮助中心',
        text2: '常见问题',
        text3: '反馈记录',
        text4: '搜寻你的疑问...',
        text5: '热门话题:',
        text6: '获得天使的协助',
        text7: '跟我们说说有关你遇到的问题细节，天使们将给你最全面的帮助',
        text8: '意见反馈',
        text9: '问题类型',
        text10: '编号:',
        text11: '客服',
        text12: '事件概述',
        text13: '创建于:',
        text14: '乐天使留言',
        text15: '请选择你的问题类型',
        text16: '关闭于:',
        text17: '选择问题类型',
        text18: '确认',
        text19: '上传相关文件',
        text20: '推荐使用',
        text21: '上传',
        text22: '附件格式支持: JPG、JPEG、PNG、GIF、PDF。',
        text23: '上传附件文件大小限制为每个文件不超过 5 MB。',
        text24: '最多可以上传 3 张。',
        text25: '提交',
        text26: 'Take photo',
        text27: 'Choose from gallery',
        text28: 'Cancel',
        text29: '离开页面？',
        text30: '您填写的内容将不会被保存。',
        text31: '离开',
        text32: '留下',
        text33: '删除图片？',
        text34: '取消',
        text35: '删除',
        text36: '预览',
        text37: '搜寻',
        text38: '搜寻结果',
        text39: '关于',
        text40: '我们为您搜寻到',
        text41: '个结果',
        text42: '关于',
        text43: `我们查无相关结果<br/>请试试搜寻其他关键字`,
        text44: '暂无相关文章',
        text45: '如需查看已提交的反馈纪录，请先登录',
        text46: '登录',
        text47: '请问有什么需要天使协助吗 ?',
        text48: '暂无记录',
        text49: '全部',
        text50: '待查看',
        text51: '处理中',
        text52: '请联系客服',
        text53: '已解决',
        text54: '已撤销',
        text55: '选择进度',
        text56: '筛选',
        text57: '选择日期',
        text577: '选择日期',
        text58: '重置',
        text59: '默认搜索时间范围为 7 天，可搜索 90 天内的记录',
        text60: '确定 (共 ',
        text61: ' 天)',
        text62: '知道了',
        text63: '只支持JPG、JPEG、PNG、GIF、PDF，并且文件大小应小于5MB。',
        text64: '发生了系统错误，请重新上传。',
        text65: '温馨提醒',
        text66: '页面将会开启另一个窗口',
        text67: '好的',
        text68: '填写意见回馈前请先登入',
        text69: '登入',
        text70: '加载中..',
        text71: '提交失败',
        text72: '系统发生错误，请稍后再试',
        text73: '提交成功',
        text74: '结束时间不能小于开始时间',
        text75: '开始时间不能大于结束时间',
        text76: '日期必须在7天内',
        text77: '选择月份 ',
        text78: '选择年份 ',
        //text79: '请输入搜索内容',
        text80: '概要',



        weekdays: ['一', '二', '三', '四', '五', '六', '日'],
        months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        text: '',
    },




    M2: {
        text1: 'ศูนย์ช่วยเหลือ',
        text2: 'คำถามทั่วไป',
        text3: 'ประวัติคำติชม',
        text4: 'ค้นหาคำถามของคุณ...',
        text5: 'คำถามที่พบบ่อย:',
        text6: 'ขอความช่วยเหลือจากนางฟ้า',
        text7: 'กรุณาแจ้งปัญหาที่ท่านพบ เหล่านางฟ้าพร้อมจะช่วยเหลือท่านอย่างครอบคลุมทุกปัญหา',
        text8: 'แจ้งปัญหา',
        text9: 'ประเภทปัญหา',
        text10: 'หมายเลขคำร้อง',
        text11: 'ฝ่ายบริการลูกค้า',
        text12: 'คำอธิบาย',
        text13: 'สร้างเมื่อ:',
        text14: 'ข้อความตอบกลับจากนางฟ้า',
        text15: 'กรุณาเลือกหัวข้อปัญหา',
        text16: 'ปิดเมื่อ:',
        text17: 'เลือกหัวข้อปัญหา',
        text18: 'ยืนยัน',
        text19: 'อัปโหลดเอกสารที่เกี่ยวข้อง',
        text20: 'รูปแบบที่แนะนำ',
        text21: 'อัปโหลด',
        text22: 'ประเภทไฟล์ที่รองรับ JPG, JPEG, PNG, GIF, PDF และขนาดไฟล์ต้องไม่เกิน 5MB.',
        text23: 'ไฟล์ที่ใช้ในการอัปโหลดขนาดต้องไม่เกิน 5 MB.',
        text24: 'สามารถแนบได้สูงสุด 3 ไฟล์.',
        text25: 'ส่ง',
        text26: 'Take photo',
        text27: 'Choose from gallery',
        text28: 'Cancel',
        text29: 'ออกจากหน้านี้',
        text30: 'ข้อความของท่านจะไม่ถูกบันทึก',
        text31: 'ออกจากหน้านี้',
        text32: 'อยู่ที่หน้านี้ต่อไป',
        text33: 'ลบรูปภาพ',
        text34: 'ยกเลิก',
        text35: 'ลบ',
        text36: 'ดูตัวอย่าง',
        text37: 'ข้อมูลบริษัท',
        text38: 'เราพบข้อมูล',
        text39: 'พบข้อมูล',
        text40: 'รายการเกี่ยวกับ',
        text41: '',
        text42: 'ไม่พบข้อมูลเกี่ยวกับ',
        text43: `<br/>กรุณาค้นหาคำใหม่`,
        text44: 'ยังไม่มีบทความที่เกี่ยวข้อง',
        text45: 'นางฟ้าสามารถช่วยเหลือท่านได้อย่างไรบ้างคะ',
        text46: 'แจ้งปัญหา',
        text47: 'นางฟ้าสามารถช่วยเหลือท่านได้อย่างไรบ้างคะ',
        text48: 'ไม่มีบันทึก',
        text49: 'ทั้งหมด',
        text50: 'รอการตรวจสอบ',
        text51: 'รอการดำเนินการ',
        text52: 'กรุณาติดต่อเจ้าหน้าที่',
        text53: 'แก้ไขแล้ว',
        text54: 'ยกเลิก',
        text55: 'เลือกสถานะ',
        text56: 'ตัวกรองค้นหา',
        text57: 'เลือกวันที่',
        text577: 'เลือกวันที่',
        text58: 'ล้างข้อมูล',
        text59: 'ช่วงเวลาการค้นหาเริ่มต้นคือ 7 วัน และสามารถค้นหาธุรกรรมภายใน 90 วันได้',
        text60: 'ตกลง (รวม ',
        text61: ' วัน)',
        text62: 'รับทราบ',
        text63: 'ประเภทไฟล์ที่รองรับ JPG, JPEG, PNG, GIF, PDF และขนาดไฟล์ต้องไม่เกิน 5MB',
        text64: 'อัพโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        text65: 'แจ้งเตือน',
        text66: 'ติดต่อฝ่ายบริการลูกค้า คลิก "ตกลง" เพื่อเปิดหน้าต่างใหม',
        text67: 'ตกลง',
        text68: 'กรุณาเข้าสู่ระบบเพื่อแจ้งปัญหาหรือกรอกความคิดเห็น',
        text69: 'เข้าสู่ระบบ',
        text70: 'กำลังโหลด...',
        text71: 'การส่งล้มเหลว',
        text72: 'ระบบเกิดข้อผิดพลาด กรุณาลองใหม่ในภายหลัง',
        text73: 'ส่งเรียบร้อยแล้ว',
        text74: '结束时间不能小于开始时间',
        text75: '开始时间不能大于结束时间',
        text76: '日期必须在7天内',
        text77: 'เลือกเดือน ',
        text78: 'เลือกปี ',
        //text79: '请输入搜索内容',
        text80: 'สรุป',



        weekdays: ['จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส', 'อา'],
        months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',],
        text: '',
    },





    M3: {
        text1: 'Trung Tâm Trợ Giúp',
        text2: 'Những Câu Hỏi Phổ Biến',
        text3: 'Lịch Sử Phản Hồi',
        text4: 'Tìm kiếm câu hỏi của bạn...',
        text5: 'Những Chủ Đề Phổ Biến:',
        text6: 'Nhận sự trợ giúp từ các thiên thần',
        text7: 'Hãy cho chúng tôi biết về bất kỳ vấn đề nào bạn gặp phải, và các thiên thần của chúng tôi sẽ trợ giúp một cách toàn diện nhất',
        text8: 'Báo Cáo Sự Cố',
        text9: 'Loại Vấn Đề',
        text10: 'Mã Số Tham Chiếu',
        text11: 'Chăm Sóc Khách Hàng',
        text12: 'Mô Tả Trường Hợp',
        text13: 'Thời Gian Tạo:',
        text14: 'Phản Hồi Của Thiên Thần',
        text15: 'Chọn Loại Vấn Đề',
        text16: 'Thời Gian Đóng:',
        text17: 'Chọn Loại Vấn Đề',
        text18: 'Xác Nhận',
        text19: 'Tải Lên Tài Liệu Liên Quan',
        text20: 'Khuyến Cáo Sử Dụng',
        text21: 'Đăng Tải',
        text22: 'Chỉ hỗ trợ định dạng file JPG, JPEG, PNG, GIF, PDF và kích thước tệp không vượt quá 5 mb.',
        text23: 'Các tệp tải lên có kích thước không vượt quá 5mb.',
        text24: 'Tối Đa 3 Tệp.',
        text25: 'Gửi',
        text26: 'Take photo',
        text27: 'Choose from gallery',
        text28: 'Cancel',
        text29: 'Rời Khỏi Trang Này?',
        text30: 'Nội Dung Quý Khách Đã Điền Sẽ không Được Lưu',
        text31: 'Rời Đi',
        text32: 'Ở Lại',
        text33: 'Xóa Hình Ảnh?',
        text34: 'Hủy Bỏ',
        text35: 'Xóa',
        text36: 'Xem Trước',
        text37: 'Tìm kiếm',
        text38: 'Kết quả tìm kiếm',
        text39: 'Chúng tôi tìm thấy',
        text40: 'kết quả về',
        text41: '',
        text42: `Không thể tìm thấy bất kỳ kết<br/>quả nào cho`,
        text43: '<br/>Vui lòng thử tìm kiếm từ khóa khác',
        text44: 'Chưa có bài viết liên quan',
        text45: 'Các thiên thần của chúng tôi có thể hỗ trợ gì cho bạn?',
        text46: 'Đăng Nhập',
        text47: 'Các thiên thần của chúng tôi có thể hỗ trợ gì cho bạn?',
        text48: 'Không có hồ sơ',
        text49: 'Tất Cả',
        text50: 'Đang Chờ Xác Minh',
        text51: 'Đang Chờ Xử Lý',
        text52: 'Vui Lòng Liên Hệ CSKH',
        text53: 'Đã Giải Quyết',
        text54: 'Đã Hủy Bỏ',
        text55: 'Chọn Trạng Thái Tiến Trình',
        text56: 'Lọc',
        text57: 'Phạm vi ngày tùy chỉnh',
        text577: 'Chọn Ngày',
        text58: 'Xác Nhận',
        text59: ' Khoảng thời gian tìm kiếm mặc định là 7 ngày và các giao dịch trong vòng 90 ngày có thể được tìm kiếm',
        text60: 'Được (tổng cộng ',
        text61: ' ngày)',
        text62: 'Đã Hiểu',
        text63: 'Chỉ hỗ trợ định dạng file JPG, JPEG, PNG, GIF, PDF và kích thước tệp không vượt quá 5 mb.',
        text64: 'Đã xảy ra lỗi, vui lòng thử tải lên lại',
        text65: 'Nhắc Nhở',
        text66: 'Trang này sẽ mở một cửa sổ khác',
        text67: 'ĐƯỢC RỒI',
        text68: 'Vui lòng đăng nhập trước khi điền vấn đề cần hỗ trợ',
        text69: 'Đăng Nhập',
        text70: 'Đang tải...',
        text71: 'Gửi không thành công',
        text72: 'Hệ thống gặp lỗi, vui lòng thử lại sau',
        text73: 'Gửi thành công',
        text74: 'Ngày kết thúc không được nhỏ hơn ngày bắt đầu',
        text75: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
        text76: 'Ngày phải trong vòng 7 ngày',
        text77: 'Chọn tháng ',
        text78: 'Chọn năm ',
        //text79: '请输入搜索内容',
        text80: 'Tóm tắt',



        weekdays: ['Hai', 'Ba', 'Tư', 'Năm', 'Sáu', 'Bảy', 'CN'],
        months: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
        text: '',
    },
}


export function HeaderDataFun(Language) {
    return [
        {
            text: CustomerText[Language]?.text2
        },
        {
            text: CustomerText[Language]?.text3
        },
    ]
}

export function ProgressStatusFun(Language) {
    return [
        {
            text: CustomerText[Language]?.text49, // all
            status: 0,
            color: 'transparent'
        },
        {
            text: CustomerText[Language]?.text50, // 待查看
            status: 1,
            color: '#FABE47'
        },
        {
            text: CustomerText[Language]?.text51, // 处理中
            status: 2,
            color: '#0076B5'
        },
        {
            text: CustomerText[Language]?.text52, // 请联系客服
            status: 3,
            color: '#EB2121'
        },
        {
            text: CustomerText[Language]?.text53, // 已解决
            status: 4,
            color: '#34C759'
        },
        {
            text: CustomerText[Language]?.text54, // 已撤销
            status: 5,
            color: '#999999'
        },
    ]
}